<template>
  <div>
    
    <TablePublic
        :colLists="weightColLists"
        :tableData="data"
        :paginationFlag="false"
        summary
        :summary-method="weightSummaryMethod"
      >
      <template slot="solts" slot-scope="scope">
        <el-button @click="lookWeightDetail(scope.data)" type="text" size="small" class="button">称重明细</el-button>
        <el-button
          @click="lookDetailFile(scope.data.weighAttachmentList)"
          type="text"
          size="small"
          class="button"
          >照片视频</el-button
        >
        <!-- <el-button @click="handleHistory(scope.data, 'weight')" type="text" size="small" class="button"
            >历史修改记录</el-button
          > -->
      </template>
    </TablePublic>

    <Mdialog
      :title="operatDialog.title"
      :visible.sync="operatDialog.visible"
      :width="operatDialog.width"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="operatDialog.visible = false"
    >
      <component
        :ref="operatDialog.currentView"
        :is="operatDialog.currentView"
        :data="operatDialog.data"
        :formType="formType"
        :imgArr="imgArr" 
        :videoArr="videoArr"
      >
      </component>

    </Mdialog>
  </div>
</template>

<script>
import TablePublic from '@/components/tablePublic.vue'
import Mdialog from '@/components/Mdialog'
import Photo from '@/components/photo.vue'
import WeightDetail from './WeightDetail.vue'
import HistoryRecord from '../HistoryRecord.vue'

import { getPickingWeighDetailList } from '@/api/manage/picking-batch-weigh'
import { getAmdRecList } from '@/api/manage/amd-rec'

const formTypeMap = {
  weight: 'picking_batch_weigh',
  trans: 'shipping_order',
}
export default {
  name: 'WeightRecord',
  components: {
    TablePublic,
    Mdialog,
    Photo,
    WeightDetail,
    HistoryRecord,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const _this = this
    return {
      weightColLists: [
        {
          prop: 'bizNo',
          label: '称重单号',
          isTrue: true,
          width: 150,
        },
        {
          prop: 'traceabilityNodeTime',
          label: '称重时间',
          isTrue: true,
          formatter(row) {
            return row.traceabilityNodeTime ? _this.parseTime(row.traceabilityNodeTime, '{y}-{m}-{d} {h}:{i}') : ''
          },
        },
        {
          prop: 'defaultUnitNetWeight',
          label: '单筐净重（斤）',
          isTrue: true,
        },
        {
          prop: 'totalQuantity',
          label: '满筐总筐数',
          isTrue: true,
        },
        {
          prop: 'tailContainerWeight',
          label: '尾筐总净重（斤）',
          isTrue: true,
        },
        {
          prop: 'totalNetWeight',
          label: '总净重（斤）',
          isTrue: true,
        },
        {
          label: '操作',
          prop: '',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 250,
          rightFlag: true,
        },
      ],

      formType: '',

      imgArr: [],
      videoArr: [],

      // 弹窗数据
      operatDialog: {
        visible: false, // 是否展示
        title: '', // 弹窗标题
        currentView: null, //当前组件
        width: '', // 弹窗宽度
        type: '', // 提交类型
        data: {}, // 数据
      },

      // 弹窗枚举
      operatEnum: {
        weightDetail: () => {
          return {
            component: 'WeightDetail',
            title: `称重明细`,
            width: '60%',
          }
        },
        photo: () => {
          return {
            component: 'Photo',
            title: `查看照片视频`,
            width: '60%',
          }
        },
        historyRecord: () => {
          return {
            component: 'HistoryRecord',
            title: `查看`,
            width: '60%',
          }
        },
      },
        
    }
  },
  mounted() {
  },
  methods: {
    onOperat(type, row) {
      // 添加操作类型
      const { component, title, width } = this.operatEnum[type]()
      this.operatDialog.title = title
      this.operatDialog.width = width
      this.operatDialog.type = type
      this.operatDialog.data = row || {}
      this.operatDialog.currentView = component
      this.operatDialog.visible = true
    },
    async lookWeightDetail(row) {
      const data = await getPickingWeighDetailList(row.id)
      console.log(data)
      if (!data.flag) return
      
      this.onOperat('weightDetail', data.data)
    },
    lookDetailFile(list) {
      this.imgArr = list?.filter((item) => item.type == 2).map((item) => item.url) || []
      this.videoArr = list?.filter((item) => item.type == 3).map((item) => ({ fileUrl: item.url })) || []

      this.onOperat('photo', {})
    },
    weightSummaryMethod(param) {
      const { columns, data } = param
      const sums = []
      console.log(columns, data, '---')

      if (!data) return sums

      // this.settleAmountPayAmount = 0
      columns.forEach((column, index) => {
        if (index == 1) {
          sums[index] = '合计'
          return
        }
        if (index == 4) {
          const total = data.reduce((prev, cur) => {
            return prev + (Number(cur.totalQuantity) || 0)
          }, 0)
          sums[index] = this.myFixed(total, 2) || '-'
          return
        }
        if (index == 5) {
          const total = data.reduce((prev, cur) => {
            return prev + (Number(cur.tailContainerWeight) || 0)
          }, 0)
          sums[index] = this.myFixed(total, 2) || '-'
          return
        }
        if (index == 6) {
          const total = data.reduce((prev, cur) => {
            return prev + (Number(cur.totalNetWeight) || 0)
          }, 0)
          sums[index] = this.myFixed(total, 2) || '-'
          return
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
    async handleHistory(row, type) {

      this.formType = formTypeMap[type]

      let formId = formTypeMap[type] === formTypeMap.trans ? row.shippingOrderId : row.id

      const data = await getAmdRecList({ formId, formType: formTypeMap[type] })
      if (data.code == 200 && data.flag) {

        this.onOperat('historyRecord', data.data)
      }
    },

  },
}
</script>

<style scoped lang="less">

</style>
